import { Button } from '@cellula/react';
import { Link } from 'react-router-dom';
import { useResolve } from '@visiba/instantiation';
import { UniversalConfig } from '@application/universal_config.service';
import { withTranslation } from '@application/i18n/with_translation';
import { ViewAppointmentState } from '../view_appointment_state.component';

interface Props {
	ticket?: string;
}

export function ScreenMissingPayment(props: Props) {
	const universalConfig = useResolve(UniversalConfig);

	return (
		<ViewAppointmentState
			title={withTranslation('View.Appointment.ScreenMissingPayment.Title')}
			description={withTranslation('View.Appointment.ScreenMissingPayment.Description')}
			actions={
				<Button as={Link} variant='primary' to={`${universalConfig.alias}/visits/video/${props.ticket ?? ''}?openPayment=true`}>
					{withTranslation('View.Appointment.ScreenMissingPayment.Continue')}
				</Button>
			}
		/>
	);
}
